import React, { createContext, useContext, useState } from "react";
import { format, startOfMonth, endOfMonth } from "date-fns";

const DashboardContext = createContext();

export function DashboardProvider({ children }) {
  const today = new Date();
  const [dateRange, setDateRange] = useState({
    startDate: startOfMonth(today),
    endDate: endOfMonth(today),
    key: "selection",
  });

  const [globalFilters, setGlobalFilters] = useState({
    selectedChannels: [],
    selectedStatus: [
      "Thành công",
      "Đã xác nhận",
      "Mới",
      "Chờ xác nhận",
      "Đang chuyển",
      "Chờ thu gom",
      "Đã đóng gói",
      "Đang xác nhận",
      "Đang đóng gói",
    ],
  });

  // Helper to get formatted strings for API calls
  const getFormattedDateRange = () => ({
    startDate: format(dateRange.startDate, "yyyy-MM-dd"),
    endDate: format(dateRange.endDate, "yyyy-MM-dd"),
  });

  const value = {
    dateRange,
    setDateRange,
    globalFilters,
    setGlobalFilters,
    getFormattedDateRange,
  };

  return (
    <DashboardContext.Provider value={value}>
      {children}
    </DashboardContext.Provider>
  );
}

export function useDashboardContext() {
  return useContext(DashboardContext);
}
